<template>
  <growth-contact-button
    v-bind="ctaBindings"
    :block="block"
    :color="color"
    :icon="icon"
    :size="size"
    skip-form-if-known-user
    :variant="variant"
    @skipped="view"
  >
    {{ label }}
  </growth-contact-button>
</template>

<script lang="ts" setup>
import type { ButtonProps } from "@pollen/ui-library";

const properties = defineProps<
  ButtonProps & {
    event: Parameters<typeof useEventReplay>[0];
  }
>();

const { ctaBindings, view } = useEventReplay(properties.event);

const label = "Voir le replay";
const icon = "ph:video";
</script>
